"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partnerZoneRequestInterceptor = function ($q, $rootScope) {
    return {
        responseError: function (response) {
            if (response.status === 401) {
                window.location.href = "/partner/user/login?returnurl=" + window.location.pathname;
            }
            return $q.reject(response);
        }
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydG5lclpvbmVSZXF1ZXN0SW50ZXJjZXB0b3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwYXJ0bmVyWm9uZVJlcXVlc3RJbnRlcmNlcHRvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVhLFFBQUEsNkJBQTZCLEdBQUcsVUFBQyxFQUFhLEVBQUUsVUFBNkI7SUFDdEYsT0FBTztRQUNILGFBQWEsRUFBRSxVQUFVLFFBQVE7WUFDN0IsSUFBSSxRQUFRLENBQUMsTUFBTSxLQUFLLEdBQUcsRUFBRTtnQkFDekIsTUFBTSxDQUFDLFFBQVEsQ0FBQyxJQUFJLEdBQUcsbUNBQWlDLE1BQU0sQ0FBQyxRQUFRLENBQUMsUUFBVSxDQUFDO2FBQ3RGO1lBRUQsT0FBTyxFQUFFLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDO1FBQy9CLENBQUM7S0FDSixDQUFDO0FBQ04sQ0FBQyxDQUFDIn0=